import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AuthContext } from '../context/authContext';
import { toast } from 'react-toastify';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(AuthContext);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!name || !email || !password || !passwordConfirmation) {
      toast.error("Please fill in all fields.");
      return;
    }

    if (password !== passwordConfirmation) {
      toast.error("Passwords do not match.");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }

    try {
      setLoading(true);
      const role_id = 1;
      const csrfToken = Cookies.get('XSRF-TOKEN');

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/register`,
        {
          name,
          email,
          password,
          password_confirmation: passwordConfirmation,
          role_id,
        },
        {
          headers: {
            'X-XSRF-TOKEN': csrfToken,
          },
          withCredentials: true,
        }
      );

      const user = response.data;
      localStorage.setItem("user", JSON.stringify(user));
      setCurrentUser(user);
      toast.success("Registration successful!");
      navigate('/');
    } catch (error) {
      const msg = error.response?.data?.message || error.message || "Unknown error";
      toast.error(`Registration failed: ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen bg-black flex items-center justify-center">
      <div className="flex flex-row-reverse max-md:flex-col-reverse h-[400px] max-md:h-fit w-[700px] bg-white border shadow-lg rounded-lg overflow-hidden">
        <div
          className="flex-1 bg-cover bg-center bg-no-repeat p-12 flex flex-col gap-2 text-white"
          style={{
            backgroundImage:
              "linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)), url('https://img.freepik.com/premium-vector/education-supplies-concept-isolated-icon_25030-13390.jpg')",
          }}
        >
          <h1 className="text-[50px] leading-none font-bold">TSL Admin</h1>
          <p>Tanzania Sign Language</p>
          <span className="text-sm">Already have an account?</span>
          <Link to="/login">
            <button className="w-1/2 py-2 bg-white text-[#120e63] font-bold cursor-pointer">
              Login
            </button>
          </Link>
        </div>
        <div className="flex-1 p-12 flex flex-col gap-4 justify-center">
          <h1 className="text-[#120e63] font-bold text-2xl">Register</h1>
          <form onSubmit={handleRegister} className="flex flex-col gap-3">
            <label htmlFor="name" className="sr-only">Name</label>
            <input
              id="name"
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
              required
            />

            <label htmlFor="email" className="sr-only">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
              required
            />

            <label htmlFor="password" className="sr-only">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
              required
            />

            <label htmlFor="passwordConfirmation" className="sr-only">Confirm Password</label>
            <input
              id="passwordConfirmation"
              type="password"
              placeholder="Confirm Password"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
              required
            />

            <button
              type="submit"
              disabled={loading}
              className={`w-1/2 py-2 font-bold text-white cursor-pointer ${
                loading ? "bg-gray-400" : "bg-[#120e63]"
              }`}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;